import * as React from "react";
const headingText = "A Tentacle agent will need to be installed on the target server to communicate with the Octopus Server.";
export const TentacleCalloutHeading: React.SFC<{
    heading?: string;
}> = ({ heading = headingText }) => (<p>
        <strong>{heading}</strong>
    </p>);
TentacleCalloutHeading.displayName = "TentacleCalloutHeading"
